import { configureStore } from '@reduxjs/toolkit'
import generalReducer from './generalReducer';

export const store = configureStore({
  reducer: {
    general: generalReducer,
  },
  middleware: (buildGetDefaultMiddleware) => buildGetDefaultMiddleware({
    serializableCheck: false
}).concat(),
})

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']